document.addEventListener('DOMContentLoaded', function () {
  const dataEl = document.getElementById('combined-listing-data');
  if (!dataEl) return;

  let combinedLinks;
  try {
    combinedLinks = JSON.parse(dataEl.textContent);
  } catch (e) { return; }

  combinedLinks.forEach(function (linkItem) {
    // 找到对应 option 名称的 fieldset
    const legends = document.querySelectorAll('.variant-selects .form-label');
    legends.forEach(function (legend) {
      // legend 文本包含 option_name（去掉冒号和空格）
      // 只取 legend 的第一个文本节点（排除 span 子元素）
const firstTextNode = Array.from(legend.childNodes)
  .find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '');
if (!firstTextNode) return;
const legendText = firstTextNode.textContent.replace(':', '').trim();
if (legendText !== linkItem.option_name) return;


      const fieldset = legend.closest('fieldset');
      if (!fieldset) return;

      const wrapper = fieldset.querySelector('.form-options-wrapper');
      if (!wrapper) return;

      // 追加跳转按钮
      linkItem.buttons.forEach(function (btn) {
        const a = document.createElement('a');
        a.href = btn.url;
        a.className = 'combined-listing-btn';
        a.textContent = btn.label;
        a.addEventListener('click', function() {
  if (typeof gtag === 'function') {
    gtag('event', 'combined_listing_click', {
      'from_product': window.location.pathname,
      'to_url': btn.url,
      'button_label': btn.label
    });
  }
});
        wrapper.appendChild(a);
      });
    });
  });
});
